// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__19YOl","content":"LayoutSettings_content__2txrm"};